import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPlaylistById } from "@store/action/multimedia/PlaylistAction";
import { Link, useParams } from "react-router-dom";
import { Play } from "react-feather";
import { Card, Col, Row, UncontrolledTooltip } from "reactstrap";
import { BsMusicNoteList } from "react-icons/bs";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import CommentByPlaylists from "./CommentByPlaylist";
import CommentForm from "./CommentForm";
import FilterBlog from "./Filter";

const PlaylistById = () => {
  const playlist = useSelector((state) => state.PlaylistReducer);
  const { t } = useTranslation();
  const shareUrl = window.location.href;
  const dispatch = useDispatch();
  const id = useParams().id;
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  let data = {
    currentsong: null,
    download: null,
    namesong: null,
    is_web_rtc: false,
    songimg: "",
  };
  useEffect(() => {
    dispatch(getPlaylistById(id));
  }, [dispatch, id]);

  const renderPlaylist = () => {
    return (
      playlist?.single && (
        <Card>
          <Row>
            <Col
              className="cursor-pointer"
              lg={6}
              onClick={() =>
                dispatch(
                  addMusic({
                    currentsong: playlist?.single[0]?.file_path,
                    namesong: `${playlist?.single[0]?.name}`,
                    item_data: playlist?.single[0],
                    is_web_rtc: false,
                    has_video:
                      playlist?.single.media?.filter(
                        (el) => el.media_type_id === 3
                      )?.length > 0
                        ? true
                        : false,
                    songimg: playlist?.single[0].picture,
                  })
                )
              }
            >
              <img
                src={playlist?.single[0]?.picture}
                width="90%"
                height="300px"
              />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "22%",
                  transform: "translate(-50%, -50%)",
                  msTransform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  color: "#8134af",
                  fontSize: "16px",
                  padding: "12px 24px",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "5px",
                  textAlign: "center",
                }}
              >
                {PlayerFrontOfficeReducer?.currentSong ===
                playlist?.single[0]?.file_path ? (
                  <BsMusicNoteList size={20} />
                ) : (
                  <Fragment>
                    <Play
                      className="mr-50 pointer_cursor "
                      id="Play"
                      style={{ display: "inline !important" }}
                      size={20}
                    />
                    <UncontrolledTooltip placement="bottom" target="Play">
                      {t("Play")}
                    </UncontrolledTooltip>
                  </Fragment>
                )}
              </div>
            </Col>

            <Col>
              <div className="mail-body mt-2">
                <div className="mail-message mt-2">
                  <h3 className="">{playlist?.single[0]?.name}</h3>
                  {/* <h4 className="text-truncate mt-2">
                    {playlist?.single[0]?.description}
                  </h4> */}

                  <h5 className="text-truncate mt-2">
                    {playlist?.single[0]?.playtime_string}
                  </h5>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      )
    );
  };
  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2> Playlist {t("Details")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/playlists">Playlist</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Playlist {t("Details")}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-part">
        <div className="container__video">
          <div className="row content-reverse">
            <FilterBlog
              t={t}
              store={playlist}
              dispatch={dispatch}
              path="playlists"
            />
            <div className="col-lg-9">
              {renderPlaylist()}
              {playlist?.single?.length && (
                <div style={{ textAlign: "center" }} className=" mt-2 mb-0">
                  <h3>{t("Share on")} </h3>
                  <ul className="blog-icon">
                    <li>
                      <FacebookShareButton url={shareUrl}>
                        <FacebookIcon size={30} round={true} />
                      </FacebookShareButton>
                    </li>
                    <li>
                      <TwitterShareButton url={shareUrl}>
                        <TwitterIcon size={30} round={true} />
                      </TwitterShareButton>
                    </li>
                    <li>
                      <WhatsappShareButton url={shareUrl}>
                        <WhatsappIcon size={30} round={true} />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <FacebookMessengerShareButton url={shareUrl}>
                        <FacebookMessengerIcon size={30} round={true} />
                      </FacebookMessengerShareButton>
                    </li>
                    <li>
                      <EmailShareButton>
                        <EmailIcon size={30} round={true} />
                      </EmailShareButton>
                    </li>
                  </ul>
                </div>
              )}
              <CommentByPlaylists t={t} />
              <CommentForm t={t} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PlaylistById;
